<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card class="card--flex-toolbar">
          <v-toolbar card class="white" prominent>
            <v-toolbar-title class="body-4 primary--text">{{ $t("please_signin") }}</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <form @submit.prevent="onSignin">
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="email"
                      :label="$t('email')"
                      id="email"
                      v-model="email"
                      type="email"
                      required
                      autofocus
                      ref="focus"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="password"
                      :label="$t('password')"
                      id="password"
                      v-model="password"
                      type="password"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6 class="text-xs-left">
                    <v-btn type="submit" :disabled="loading" :loading="loading">
                      {{ $t("signin") }}
                      <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 class="text-xs-right">
                    <router-link to="/forget-password" :disabled="loading">
                      {{ $t("forget_password") }}
                    </router-link>
                  </v-flex>
                </v-layout>
                <v-layout row class="mt-4">
                  <v-flex xs12 class="text-xs-center">
                    <router-link to="/signup" :disabled="loading">
                      {{ $t("do_signup") }}
                    </router-link>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { HTTP, showError } from '../../utils'

export default {
  data () {
    return {
      email: '',
      password: '',
      loading: false
    }
  },

  mounted () {
    requestAnimationFrame(() => {
      this.$refs.focus.focus()
    })
  },

  methods: {
    onSignin () {
      const self = this
      const data = {
        email: this.email,
        password: this.password
      }
      this.loading = true
      HTTP.post('signin', data)
        .then(response => {
          this.loading = false
          const data = response.data
          if (data.status < 0) {
            console.log('Signin error: ' + data.message)
            showError(self, data.message)
          } else {
            this.$store.commit('setUser', data.user)
            this.$router.push('/search')
          }
        })
        .catch(error => {
          console.log('SignIn error: ' + error.message)
          this.loading = false
          showError(self, error.message)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User/Signin.vue